export default __webpack_public_path__ + "static/media/300_2 1.17b77c56.svg";